"use client";

import FavoritesHeader from "@/views/favorites/components/favorites-header";
import FavoritesContent from "@/views/favorites/components/favorites-content";
import { observer } from "mobx-react-lite";
import { useStore } from "@/hooks/system/useStore";
import { useMedia } from "@/hooks/system/useMedia";
import FavoritesLoading from "./components/favorites-loading";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const FavoritesView = () => {
  const { selectedFilters } = useStore("favorite");
  const { isClient } = useMedia();

  if (!isClient)
    return (
      <div className={S.mainWrapper}>
        <FavoritesLoading />
      </div>
    );

  return (
    <div className={S.mainWrapper}>
      <FavoritesHeader count={selectedFilters.productGuids.length} />
      <Container>
        <FavoritesContent count={selectedFilters.productGuids.length} />
      </Container>
    </div>
  );
};

export default observer(FavoritesView);
